import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';
import { brandPrimary, charmGray } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	content: {
		display: 'flex',
		flexDirection: 'column',
		paddingTop: SPACE[24],
		width: '100%',
		maxWidth: '100%',
		color: THEME.colors.text.dark,
		boxSizing: 'border-box',
	},
	description: {
		fontSize: '14px',
		margin: 0,
		lineHeight: '1.5',
		opacity: 0.9,
	},
	tableContainer: {
		position: 'relative',
		border: `1px solid ${charmGray}`,
		borderRadius: '8px',
		overflow: 'hidden',
	},
	bulkActionsContainer: {
		marginBottom: '16px',
		padding: '16px',
		backgroundColor: 'rgba(255, 255, 255, 0.05)',
		border: `1px solid ${charmGray}`,
		borderRadius: '8px',
	},
	bulkActionsContent: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '12px',
	},
	selectedCount: {
		fontSize: '14px',
		fontWeight: 500,
	},
	bulkActions: {
		display: 'flex',
		gap: 12,
		flexWrap: 'wrap',
	},
	customMessageRow: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	customMessageLabel: {
		fontSize: '13px',
		fontWeight: 500,
		opacity: 0.9,
		display: 'flex',
		alignItems: 'center',
		gap: SPACE[8],
	},
	customMessagePreview: {
		fontSize: '12px',
		fontStyle: 'italic',
		fontWeight: 'normal',
	},
	customMessagePlaceholder: {
		fontSize: '12px',
		fontWeight: 'normal',
	},
	editMessageButton: {
		padding: '4px 8px',
		backgroundColor: 'transparent',
		color: brandPrimary,
		border: `1px solid ${brandPrimary}`,
		borderRadius: '4px',
		fontSize: '12px',
		fontWeight: 500,
		cursor: 'pointer',
		transition: 'background-color 0.2s, color 0.2s',
		':hover': {
			backgroundColor: brandPrimary,
			color: '#FFFFFF',
		},
	},
	root: {
		display: 'grid',
		gridTemplateColumns: 'minmax(0, 1fr) auto',
		height: '100%',
		justifyItems: 'center',
	},
	callAnalysisRoot: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		overflowY: 'auto',
		overflowX: 'hidden',
	},
	drawer: {
		overflow: 'hidden',
	},
	drawerContent: {
		borderTopLeftRadius: 16,
	},
	tabContent: {
		width: '100%',
		minHeight: 600,
	},
});
